import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Instagram, Mail } from "lucide-react";

export function Footer() {
  const [brandLogo, setBrandLogo] = useState("");
  useEffect(() => {
    api.get("/public-settings").then(({ data }) => setBrandLogo(data.brand_logo || "")).catch(() => {});
  }, []);

  return (
    <footer data-testid="site-footer" className="border-t border-zinc-800 bg-[#0a0a0c]">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 lg:grid-cols-3 lg:px-8">
        <div className="space-y-4">
          {brandLogo ? (
            <img data-testid="footer-logo" src={brandLogo} alt="MX Dance" className="h-10 w-auto object-contain" />
          ) : (
            <Link to="/" data-testid="footer-logo" className="flex items-center gap-2">
              <span className="h-6 w-1.5 rounded-full bg-[#ff2a5f]" />
              <span className="font-display text-xl font-extrabold uppercase tracking-tight text-white">MX Dance</span>
            </Link>
          )}
          <p className="max-w-xs text-sm leading-relaxed text-zinc-500">
            Professional media for dancers. Every move, captured in its best light.
          </p>
        </div>
        <div className="space-y-3">
          <div className="font-mono-x text-xs uppercase tracking-widest text-zinc-500">Explore</div>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><Link to="/" data-testid="footer-store" className="transition-colors hover:text-white">Store</Link></li>
            <li><Link to="/dashboard" data-testid="footer-orders" className="transition-colors hover:text-white">My Orders</Link></li>
            <li><Link to="/downloads" data-testid="footer-downloads" className="transition-colors hover:text-white">My Downloads</Link></li>
          </ul>
        </div>
        <div className="space-y-3">
          <div className="font-mono-x text-xs uppercase tracking-widest text-zinc-500">Get in touch</div>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><a href="mailto:info@mx.dance" className="inline-flex items-center gap-2 transition-colors hover:text-white"><Mail className="h-4 w-4" /> info@mx.dance</a></li>
            <li><a href="https://www.instagram.com/mx.mvmt" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 transition-colors hover:text-white"><Instagram className="h-4 w-4" /> Instagram</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-800/70 py-5 text-center font-mono-x text-xs uppercase tracking-widest text-zinc-600">
        © {new Date().getFullYear()} MX Dance — Media Portal
      </div>
    </footer>
  );
}
